export default __webpack_public_path__ + "static/media/Padron_5000Closed.68d0b972.jpg";